import { toast } from 'design-system';

export default async function copyToClipboard(textToCopy: string, toastMessage: string) {
  try {
    await navigator.clipboard.writeText(textToCopy);
    toast.add({ title: toastMessage, type: 'success', timeout: 5000 });
  } catch {
    toast.add({ title: 'Failed to copy to clipboard', type: 'error', timeout: 5000 });
  }
}
